import {
  IObjektVy,
  IBusinessCollectionProps,
} from '../../../../../Types/ObjektVy';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { IColumnDef } from '../../../../../Types/ColumnDefType';
import ConnectedAttributeField from '../../../../../Components/Attributes/Form/Components/ConnectedAttributeField/ConnectedAttributeField';
import ConnectedListField from '../../../../../Components/Attributes/Form/Components/ConnectedListField/ConnectedListField';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';

export const columnListVy = (
  columndef: IColumnDef,
  id?: string
): IObjektVy => ({
  type: 'ObjektVy',
  id: id || columndef.attributeDef,
  info: { komponentMedRubrik: true },
  def: (businessModel: IClientBusinessModel) => {
    const comp = (props: IBusinessCollectionProps) => {
      return (
        <ConnectedListField
          collection={businessModel}
          columndef={columndef}
          objectId={selectedId(props.id)}
        />
      );
    };
    return {
      caption: columndef.caption || 'Caption saknas',
      comp: comp,
    };
  },
});

// vy som använder en columndef istället för fältnamn
// kanske ska ersätta fältvyer och i så fall byta namn
const columnDefVy = (columndef: IColumnDef, _id?: string): IObjektVy => ({
  type: 'ObjektVy',
  id: columndef.attributeDef,
  info: { komponentMedRubrik: true },
  def: (businessModel: IClientBusinessModel) => {
    const comp = (props: IBusinessCollectionProps) => {
      return (
        <ConnectedAttributeField
          collection={businessModel}
          attributePath={columndef.attributeDef}
          objectId={selectedId(props.id)}
        />
      );
    };
    return {
      caption: columndef.caption || 'Caption saknas',
      comp: comp,
    };
  },
});

export default columnDefVy;
